import { useTranslation } from 'react-i18next';
import './ComingSoonTag.scss'

export const ComingSoonTag = () => {
  const { t } = useTranslation();

  return (
    <div className="coming-soon-tag">
      <div className="coming-soon-tag-text">{t('ComingSoon', { ns: 'learningHub' })}</div>
    </div>
  )
}
